import get from 'lodash/get';
import invoke from 'lodash/invoke';
import { clearErrors } from 'store/error/errorActions';
import { registerSplits } from 'store/split/splitActions';
import { isServer } from 'lib/renderHelpers';

export const routeChangeHandler = ({ store, routeBefore, routeAfter, routeAction }) => {
  store.dispatch(clearErrors());

  invoke(routeBefore.component, 'onExitPage', { store, route: routeBefore });
  invoke(routeAfter.component, 'onEnterPage', { store, route: routeAfter });

  const doesNavigateForward = routeAction === 'PUSH';

  if (!isServer() && doesNavigateForward) {
    window.scrollTo(0, 0);

    const activeSplits = get(routeAfter, 'component.activeSplits');
    if (activeSplits) store.dispatch(registerSplits(activeSplits));
  }
};
